<template>
  <div class="detail_talents">
    <el-row>
      <el-col :span="24">
        <el-table
          :header-cell-style="{'background-color':'#FAFAFA','color':'black','font-weight':'bold','height': '54px'}"
          :data="data"
          style="width: 100%"
        >
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form
                label-position="left"
                label-width="80px"
                class="demo-table-expand"
              >
                <el-form-item label="姓名:">
                  <span class="display-detail">{{ props.row.name }}</span>
                </el-form-item>
                <el-form-item label="证书类别:">
                  <span class="display-detail">{{ props.row.proveType }}</span>
                </el-form-item>
                <el-form-item label="证书编号:">
                  <span class="display-detail">{{ props.row.proveNo == null || props.row.proveNo == ''?'/': props.row.proveNo }}</span>
                </el-form-item>
                <el-form-item label="发证机关:">
                  <span class="display-detail">{{ props.row.proveOrg == null || props.row.proveOrg == ''?'/': props.row.proveOrg }}</span>
                </el-form-item>
                <el-form-item label="人才简介:">

                  <!-- <span class="display-detail">{{ props.row.introduce == null || props.row.introduce == ''?'/': props.row.introduce }}</span> -->

                  <span
                    class="display-detail"
                    style="white-space: pre-wrap;"
                    v-if="props.row.introduce"
                    v-html="props.row.introduce"
                  ></span>

                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column
            label="姓名"
            prop="name"
          >
            <template slot-scope="scope">
              <span class="column-line">{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="证书类别"
            prop="proveType"
          >
            <template slot-scope="scope">
              <span class="column-line">{{scope.row.proveType == null || scope.row.proveType == ''? '/': scope.row.proveType}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="证书编号"
            prop="proveNo"
          >
            <template slot-scope="scope">
              <span class="column-line">{{scope.row.proveNo  == null || scope.row.proveNo == ''? '/': scope.row.proveNo}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="发证机关"
            prop="proveOrg"
          >
            <template slot-scope="scope">
              <span class="column-line">{{scope.row.proveOrg  == null || scope.row.proveOrg == ''? '/': scope.row.proveOrg}}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col
        :span="24"
        style="margin-top:20px;margin-bottom:20px"
      >
        <!-- <el-col :span="11" style="height:30px;"></el-col> -->
        <el-col
          :span="24"
          style="text-align:center"
        >
          <el-pagination
            :page-size="20"
            background
            @current-change="pageChange"
            layout="prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </el-col>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: function () {
        return []
      }
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {}
  },
  methods: {
    pageChange (val) {
      this.$emit('barcChange', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px !important;
}
.column-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.display-detail {
  color: #333;
}
</style>
<style lang="scss">
.detail_talents{
  .el-table th,
  .el-table tr {
    height: 54px !important;
  }
  .detail_talents .el-table {
    color: #666 !important;
    border: 1px solid #e4e7ed;
    border-bottom: none;
    border-top: 0px;
    border-radius: 0 0 4px 4px;
    font-size: 14px;
  }
  .el-pager li {
    background-color: transparent;
  }
  .el-pager li.active {
    background-color: transparent !important;
    color: #0286df !important;
  }
}

</style>
